import Vue from 'vue'
import { vfmPlugin } from 'vue-final-modal/lib'
import { v4 as uuid } from 'uuid'

Vue.use(vfmPlugin)

const msgBox = (options, component = 'DTMsgBox') => {
  const { $vfm } = Vue.prototype
  return new Promise((resolve) => {
    $vfm.show({
      component,
      id: uuid(),
      bind: Object.assign(
        { size: 'xs', okVariant: 'blue', zIndexBase: 2000 },
        options,
      ),
      on: {
        confirm(close) {
          close()
          return resolve(true)
        },
        cancel(close) {
          close()
          return resolve(false)
        },
        closed() {
          return resolve(null)
        },
      },
    })
  })
}

export default (context, inject) => {
  inject('DTMsgBox', msgBox)
}
